"use client";

import { AccountAddress } from "@aptos-labs/ts-sdk";
import { useSearchParams } from "next/navigation";

export function useOverrideAddress() {
  const searchParams = useSearchParams();
  const accountParam = searchParams.get("address");

  return {
    overriddenAccountAddress: accountParam ? AccountAddress.fromString(accountParam) : undefined,
    isAccountOverridden: !!accountParam,
  };
}
